<script>
import { mapMutations, mapGetters } from 'vuex';
import { find } from 'lodash';

import {
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_INFO,
  NOTIFICATION_TYPE_WARNING,
  NOTIFICATION_TYPE_MESSAGE,
} from 'src/store/modules/notification';

export default {
  timer: 0,
  props: {
    data: {
      type: Object,
      require: true,
    },
  },
  mounted() {
    if (this.data.duration) {
      this.timer = setTimeout(() => this.NOTIFICATION_DELETE(this.data), this.data.duration);
    }
  },
  methods: {
    ...mapMutations('notification', ['NOTIFICATION_DELETE']),
  },
  computed: {
    ...mapGetters('app', ['isUcEnv']),
    isChatWidget() {
      return find(this.$parent.$children, (item) => item.$el !== undefined
        && item.$el.className === 'chatWorkflow') !== undefined;
    },
    color() {
      switch (this.data.type) {
        case NOTIFICATION_TYPE_SUCCESS:
          return 'green';
        case NOTIFICATION_TYPE_ERROR:
          return 'red';
        case NOTIFICATION_TYPE_INFO:
          return 'blue';
        case NOTIFICATION_TYPE_WARNING:
          return 'orange';
        case NOTIFICATION_TYPE_MESSAGE:
          return 'blue';
        default:
          return 'gray';
      }
    },
    type() {
      switch (this.data.type) {
        case NOTIFICATION_TYPE_SUCCESS:
          return 'done';
        case NOTIFICATION_TYPE_ERROR:
          return 'error';
        case NOTIFICATION_TYPE_INFO:
          return 'info';
        case NOTIFICATION_TYPE_WARNING:
          return 'warning';
        case NOTIFICATION_TYPE_MESSAGE:
          return 'message';
        default:
          return null;
      }
    },
  },
};
</script>

<template lang="pug">
div(:class="[$style.root, isChatWidget && $style.chatNotification, isUcEnv && $style.chatNotificationUc]")
  div(:class="[$style.header, $style[color]]")
    div(:class="$style.type" v-if="type")
      ui-icon(:class="$style.icon") {{ type }}
    div(:class="$style.title") {{ data.title }}
    ui-icon(:class="$style.close", @click.native="NOTIFICATION_DELETE(data)",
      @keyup.enter.native="NOTIFICATION_DELETE(data)", tabindex="0",
      v-if="data.duration") close
  div(:class="$style.body" v-if="data.body") {{ data.body }}

</template>

<style module lang="sass">
.root
  overflow: hidden
  width: 320px
  background: #fff
  box-sizing: border-box
  padding: 16px
  margin: 8px
  box-shadow: $sh_dp3
.header
  display: flex
  align-items: center
  min-height: 24px
.title
  flex-grow: 1
  font-size: 15px
  font-weight: 300
.body
  margin-top: 4px
  font-size: 12px
  color: $color_text
  overflow-wrap: break-word
  word-wrap: break-word
  word-break: break-all
  word-break: break-word
.type
  flex-grow: 0
  margin-right: 8px
.icon
  width: 24px
  height: 24px
.green
  color: $color_green
.red
  color: $color_red
.blue
  color: $color_blue
.orange
  color: $color_orange
.gray
  color: $color_gray
.close
  width: 24px
  height: 24px
  color: $color_text_second
  flex-grow: 0
  cursor: pointer
  &:hover
    color: $color_text
  &:focus
    color: $color_text
    outline: none
.chatNotification
  max-width: 300px
  padding: 8px
  .icon .close
    width: 20px
    height: 20px
.chatNotificationUc
  padding: 16px
  font-family: "Uc", sans-serif
  max-width: 320px
  .title
    font-size: 18px
    font-weight: 400
  .body
    font-size: 14px
</style>
